import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedTime, FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { Image } from 'components/Image/Image';
import { StarRating } from 'components/StarRating/StarRating';
import { interpolate } from 'helpers/interpolate';
import { deepExtract } from 'helpers/deep';
import { nextMidnight } from 'components/CountdownTimer/CountdownTimer';
import { Image as ImageModel, RES } from 'models/Image';
import { stringSeparatedWords } from './helpers';
import { OfferExpiryCountdown } from './OfferExpiryCountdown';

export class ClassAvailable extends PureComponent {
  render() {
    const { ctaText, displayName, legal, purchaseUrl, schedule, subtitle, title } = this.props;
    const venue = deepExtract('venue', schedule, {});
    const venueAddress = deepExtract('address', venue, {});
    const interpolationConfig = {
      $USER_NAME: displayName,
      $VENUE_NAME: deepExtract('name', venue, ''),
    };
    const classStartTime = schedule.starttime * 1000;
    const promoTitle = interpolate(title, interpolationConfig);
    const promoSubtitle = interpolate(subtitle, interpolationConfig);
    const { ratings } = venue;
    // The campaign service has yet to be updated to return any images other than `default`, so we fall back to it for now
    // See: https://classpass.atlassian.net/browse/CRO-2103
    const imageUrl = ImageModel.getImage(venue?.images, RES.med) || venue?.images?.default;
    const venueNameAndAlias = stringSeparatedWords(' • ', venue.name, deepExtract('location.name', venue));
    const classAdressLine1 = stringSeparatedWords(', ', venueAddress.address_line1, venueAddress.address_line2);
    const classAdressLine2 = stringSeparatedWords(', ', venueAddress.city, venueAddress.state, venueAddress.zip_code);
    const nextMidnightTime = nextMidnight();
    const countdownTo = nextMidnightTime > classStartTime ? classStartTime : nextMidnightTime;
    return (
      <section className="class-available">
        <p className="class-available__mobile-title">{promoTitle}</p>
        <div className="class-available__class-detail">
          <Image url={imageUrl} alt="venue" />
          <div className="class-available__class-detail__content">
            <h3 className="epsilon mb-">{schedule.class.name}</h3>
            <div className="color-text-light mb">
              {venueNameAndAlias}
              <br />
              {!!ratings && <StarRating rating={ratings.mean} showRatingNumber />}
            </div>
            <p className="color-text-light">
              <FormattedMessage
                id="inviteafriend.day-and-time"
                defaultMessage="{classDay}, {classDate} at {classTime}"
                values={{
                  classDay: <FormattedDate weekday="long" value={classStartTime} />,
                  classDate: <FormattedDate day="numeric" month="short" value={classStartTime} />,
                  classTime: <FormattedTime value={classStartTime} hour="numeric" minute="numeric" />,
                }}
              />
              <br />
              {classAdressLine1}
              <br />
              {classAdressLine2}
            </p>
          </div>
        </div>
        <div className="class-available__promo">
          <div className="class-available__promo__offer">
            <h2 className="class-available__promo__offer__header mb">{promoTitle}</h2>
            {!!subtitle && <p className="class-available__promo__offer__subtitle">{promoSubtitle}</p>}
          </div>
          <div>
            <Link to={purchaseUrl} className="class-available__promo__cta bt bt--primary mb-">
              {ctaText}
            </Link>
          </div>
          {!!legal && <p className="class-available__promo__legal color-text-light text--sm">{legal}</p>}
          <OfferExpiryCountdown countdownTo={countdownTo} />
        </div>
      </section>
    );
  }
}

ClassAvailable.propTypes = {
  ctaText: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  legal: PropTypes.string,
  purchaseUrl: PropTypes.string.isRequired,
  schedule: PropTypes.object,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};
